import React from 'react';
import { motion } from 'framer-motion';
import { Heart, Users, Shield, Sparkles } from 'lucide-react';
const valueProps = [{
  icon: Heart,
  title: 'Integrity, Honesty, Compassion',
  description: 'Our practice ideals guide every treatment plan and every conversation we have with you.'
}, {
  icon: Users,
  title: 'Family Oriented',
  description: 'A welcoming practice for patients of every age — from your kids to your grandparents.'
}, {
  icon: Sparkles,
  title: 'Highest Level of Care',
  description: 'We constantly challenge ourselves through continuing education to deliver exceptional outcomes.'
}, {
  icon: Shield,
  title: 'Your Well-Being First',
  description: 'A relaxed, inviting atmosphere where your comfort and best interests are always paramount.'
}];
export function About() {
  return <section id="about" className="py-24 bg-cream overflow-hidden" data-id="element-10">
      <div className="max-w-7xl mx-auto px-6 lg:px-8" data-id="element-11">
        <div className="grid lg:grid-cols-2 gap-16 items-center" data-id="element-12">
          <motion.div initial={{
          opacity: 0,
          x: -30
        }} whileInView={{
          opacity: 1,
          x: 0
        }} viewport={{
          once: true,
          margin: '-100px'
        }} transition={{
          duration: 0.7
        }} className="relative" data-id="element-13">
            <div className="relative rounded-[2rem] overflow-hidden aspect-square lg:aspect-[4/5]" data-id="element-14">
              <img src="https://images.unsplash.com/photo-1606811971618-4486d14f3f99?ixlib=rb-4.0.3&auto=format&fit=crop&w=1000&q=80" alt="Bright, modern dental office reception area" className="w-full h-full object-cover" data-id="element-15" />
              <div className="absolute inset-0 bg-sage-900/10 mix-blend-multiply" data-id="element-16"></div>
            </div>

            {/* Decorative element */}
            <div className="absolute -bottom-8 -right-8 w-48 h-48 bg-coral-100 rounded-full blur-3xl -z-10" data-id="element-17"></div>
            <div className="absolute -top-8 -left-8 w-48 h-48 bg-sage-100 rounded-full blur-3xl -z-10" data-id="element-18"></div>
          </motion.div>

          <motion.div initial={{
          opacity: 0,
          x: 30
        }} whileInView={{
          opacity: 1,
          x: 0
        }} viewport={{
          once: true,
          margin: '-100px'
        }} transition={{
          duration: 0.7
        }} data-id="element-19">
            <h2 className="text-sage font-semibold tracking-wider uppercase text-sm mb-3" data-id="element-20">
              Our Mission
            </h2>
            <h3 className="text-4xl md:text-5xl font-serif text-charcoal-800 mb-6 leading-tight" data-id="element-21">
              The highest quality care — without the cold clinic feeling.
            </h3>
            <p className="text-lg text-charcoal-500 mb-6 leading-relaxed" data-id="element-22">
              Dr. Dennis Martin and our staff have served the Lincoln area since
              2001 and Waverly since 2003 with a simple mission: to provide the
              highest quality of care while staying true to our practice ideals
              of integrity, honesty, and compassion.
            </p>
            <p className="text-lg text-charcoal-500 mb-10 leading-relaxed" data-id="element-23">
              An aesthetically beautiful smile is often tied to self-esteem and
              confidence — and we'll work alongside you to maintain yours in a
              relaxing, comfortable environment.
            </p>

            <div className="grid sm:grid-cols-2 gap-8" data-id="element-24">
              {valueProps.map((prop, index) => <div key={index} className="flex flex-col gap-3" data-id="element-25">
                  <div className="w-12 h-12 bg-white rounded-xl flex items-center justify-center text-coral shadow-sm" data-id="element-26">
                    <prop.icon size={24} strokeWidth={2} data-id="element-27" />
                  </div>
                  <h4 className="text-lg font-serif font-medium text-charcoal-800" data-id="element-28">
                    {prop.title}
                  </h4>
                  <p className="text-sm text-charcoal-500 leading-relaxed" data-id="element-29">
                    {prop.description}
                  </p>
                </div>)}
            </div>
          </motion.div>
        </div>
      </div>
    </section>;
}